/**
 * <why-eleo-slider>
 *
 * Activates Swiper only on mobile (< 750px).
 * On desktop the CSS grid takes over and Swiper is inactive.
 */
class WhyEleoSlider extends HTMLElement {
  /** @type {import('swiper').Swiper | null} */
  #swiper = null;
  #mq = window.matchMedia('(max-width: 749px)');
  #bound = this.#onBreakpoint.bind(this);

  connectedCallback() {
    this.#mq.addEventListener('change', this.#bound);
    this.#onBreakpoint(this.#mq);

    document.addEventListener('shopify:section:load', (event) => {
      if (event.target.contains(this)) {
        this.#swiper?.destroy(true, true);
        this.#swiper = null;
        this.#onBreakpoint(this.#mq);
      }
    }, { once: true });
  }

  disconnectedCallback() {
    this.#mq.removeEventListener('change', this.#bound);
    this.#swiper?.destroy(true, true);
    this.#swiper = null;
  }

  #onBreakpoint(e) {
    if (e.matches) {
      this.#initSwiper();
    } else {
      this.#swiper?.destroy(true, true);
      this.#swiper = null;
    }
  }

  #initSwiper() {
    if (this.#swiper) return;

    const init = () => {
      const swiperEl = this.querySelector('.why-eleo__swiper');
      if (!swiperEl) return;

      // Shopify wraps each block in .shopify-block — Swiper needs swiper-slide on direct children
      swiperEl.querySelectorAll(':scope .swiper-wrapper > .shopify-block').forEach(el => {
        el.classList.add('swiper-slide');
      });

      const prevBtn = this.querySelector('.why-eleo__btn--prev');
      const nextBtn = this.querySelector('.why-eleo__btn--next');

      const pagination = this.querySelector('.why-eleo__pagination');

      this.#swiper = new Swiper(swiperEl, {
        slidesPerView: 1,
        spaceBetween: 0,
        centeredSlides: true,
        grabCursor: true,
        a11y: false,
        navigation: {
          prevEl: prevBtn,
          nextEl: nextBtn,
          disabledClass: 'swiper-button-disabled',
        },
        pagination: {
          el: pagination,
          clickable: true,
          type: 'bullets',
        },
      });
    };

    if (typeof Swiper !== 'undefined') {
      init();
    } else {
      const swiperScript = document.querySelector('script[src*="swiper-bundle"]');
      if (swiperScript) {
        swiperScript.addEventListener('load', init, { once: true });
      }
    }
  }
}

customElements.define('why-eleo-slider', WhyEleoSlider);
